import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';

import { Observable, map } from 'rxjs';

import { environment } from '../../../environments/environment';
import { Tenant } from '../interfaces';

interface TenantApiItem {
  uuid: string;
  name: string | null;
  subDomain: string | null;
  webUrl: string | null;
  active: boolean;
  roles: readonly string[] | null;
}

const TENANTS_PATH = '/control_center/me/tenants';

@Injectable({ providedIn: 'root' })
export class TenantService {
  private readonly http = inject(HttpClient);

  getMyTenants(): Observable<readonly Tenant[]> {
    const url = buildTenantsUrl(environment.apiBaseUrl);
    return this.http.get<readonly TenantApiItem[]>(url).pipe(map((items) => items.map(mapTenant)));
  }
}

function buildTenantsUrl(base: string): string {
  if (!base) {
    return TENANTS_PATH;
  }

  return `${base.replace(/\/+$/, '')}${TENANTS_PATH}`;
}

function mapTenant(item: TenantApiItem): Tenant {
  return {
    uuid: item.uuid,
    name: item.name ?? item.subDomain ?? item.uuid,
    subDomain: item.subDomain,
    webUrl: item.webUrl,
    roles: item.roles ?? [],
  };
}
